import * as React from 'react';

import EventProcedureDetailsView from 'security-app/components/SecurityEvents/EventProcedures/EventProcedureDetailsView';
import type {
  EventProceduresAPIType,
  EventProcedureStepAPIType,
} from 'security-app/hooks/api/eventProceduresAPI.types';

function useTableElements() {
  const renderExpanded = React.useCallback(
    (eventProcedure: EventProceduresAPIType<Array<EventProcedureStepAPIType>>) => (
      <EventProcedureDetailsView eventProcedure={eventProcedure} descriptionMaxHeight={400} row />
    ),
    [],
  );

  const expandedSections = React.useMemo(
    () => ({
      restFieldsExpandedSection: {
        title: null,
        content: renderExpanded,
      },
    }),
    [renderExpanded],
  );

  return {
    expandedSections,
  };
}

export default useTableElements;
